import { getCategoriesChecked } from './products';
import { PRODUCT_ADDONS_TYPE, PRODUCT_ADDONS, PRODUCT_VARIATION_ID_PREFIX } from './constants';

const formatComboVariations = (steps, variations) => {
  if (!variations || !variations.length) {
    return [];
  }

  let nextId = steps
    .map(step => step.id)
    .sort()
    .pop();
  return variations.map(variation => {
    nextId += 1;
    return {
      id: nextId,
      addonType: PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS,
      data: variation,
    };
  });
};

const formatComboProducts = (comboProducts, categories) => {
  if (!comboProducts || !comboProducts.length) {
    return [];
  }
  return comboProducts.map(combo => ({
    id: combo.id,
    title: combo.name,
    addonType: PRODUCT_ADDONS.SELECTED_PRODUCTS,
    isEdit: true,
    data: getCategoriesChecked(combo.products, categories),
  }));
};

export const formatProductComboData = (product, categories) => {
  const globalVariations = product.globalVariations || null;
  const comboProducts = product.comboProductSteps;
  let steps = [];

  steps = formatComboProducts(comboProducts, categories);

  return steps.concat(formatComboVariations(steps, globalVariations));
};

export const getAddonType = product => {
  return product.comboProductSteps && product.comboProductSteps.length
    ? PRODUCT_ADDONS_TYPE.PRODUCTS
    : product.globalVariations && product.globalVariations.length
    ? PRODUCT_ADDONS_TYPE.VARIATIONS
    : null;
};

export const sortVariations = (variations = []) =>
  [...variations].sort((nextVar, currVar) => nextVar.sortOrder - currVar.sortOrder);

export const hasVariationsAddon = product => {
  const hasProductVariations = product.productVariations && product.productVariations.length;
  const hasGlobalVariations = product.globalVariations && product.globalVariations.length;

  return hasGlobalVariations || hasProductVariations;
};

export const getChildProductVariations = product => {
  const globalVariations = product.globalVariations ? product.globalVariations : [];
  const productVariations = product.productVariations ? product.productVariations : [];
  const variations =
    product.productType === PRODUCT_ADDONS_TYPE.VARIATIONS
      ? sortVariations([...globalVariations, ...productVariations])
      : [...globalVariations];

  return variations.slice(0, 5);
};

export const isProductVariationAddon = variation => {
  return variation && typeof variation.id === 'string'
    ? variation.id.includes(PRODUCT_VARIATION_ID_PREFIX)
    : false;
};



// WEBPACK FOOTER //
// ./src/helpers/addons.js